/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CoursePrice } from './CoursePrice';
import { CourseState } from './CourseState';
import { Restriction } from './Restriction';
const CourseParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['name', codecString],
    ['createdAt', parsers.moment, 'created_at'],
    ['virtual', codecBoolean],
    ['state', CourseState],
    ['tenantId', /* #__PURE__ */ parsers.maybeNull(codecString), 'tenant_id'],
    ['price', /* #__PURE__ */ parsers.maybeNull(CoursePrice)],
    ['accessRestrictions', Restriction, 'access_restrictions'],
]));
export class Course extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CourseParser.decode(input).map(res => new Course(res));
    }
    static unsafeDecode(input) {
        return Course.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseParser.encode(data);
    }
    static schema() {
        return CourseParser.schema();
    }
}
